export default __webpack_public_path__ + "static/media/nft-5.738fd8b5.png";